import React from "react"
import { FaChevronUp } from "react-icons/fa"
import Navbar from "../../../@shared/navigations/default";
import FilterVertical from "./vertical-filtering";
import ListView from "./view/list";
import GridView from "./view/grid";
import { Filtering, FilterTabs } from "./filtering";
   
export const ProjectsFilterPage = () => {
  return (
    <React.Fragment>
    <Navbar />
     <Filtering /> 
     <FilterTabs /> 
      <div className="projects-page">

        <div className="project_list_page">
          <div className="container5">
            <div className="">
               {/*  */}
               <FilterVertical />
              <div>
                 <ListView />
                 <GridView />
                {/* <View /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="scrollTop" onClick={() => {
          document.getElementsByTagName('html')[0]
            .scrollIntoView({ behavior: "smooth", inline: "nearest" })
        }}>
          <FaChevronUp />
        </div>
      </div>
    </React.Fragment>
  )
}



export default ProjectsFilterPage;

